"use strict";

import {optionsFromCapabilities} from "ol/source/WMTS";

/**
 * @classdesc
 * Openlayers-Wrapper des WMTS-Providers.
 *
 * @class
 * @extents gc.gis.map.GCAbstractWMTSProvider
 * @memberof gc.gis
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.util.GCRequestManager} requestManager
 */
gc.gis.OLWMTSProvider = function(requestManager)
{
   gc.gis.map.GCAbstractWMTSProvider.call(this, requestManager);
};
gc.gis.OLWMTSProvider.prototype = Object.create(gc.gis.map.GCAbstractWMTSProvider.prototype);

/**
 * @inheritDoc
 */
gc.gis.OLWMTSProvider.prototype.getCapabilities = function(url, onResponse)
{
    const self = this;
    const capabilitiesUrl = this._buildCapabilitiesUrl(url);
    const parser = new gc.gis.format.OLWmtsCapabilities();

    this.requestManager.ajax({
        label: 'Lade WMTS-Capabilities ... ',
        url: capabilitiesUrl,
        success: function(data) {
            const capabilities = parser.read(data);

            if(typeof onResponse === 'function')
            {
                onResponse.call(self, capabilities);
            }
            else
            {
                throw new gc.gis.error.GCError('No callback defined to process WMTS capabilities! Doing nothing.');
            }
        },
        error: function(err) {
            throw new gc.gis.error.GCError(`Failed to retrieve wmts capabilities: ${capabilitiesUrl}`, err);
        }
    });
};

/**
 * @inheritDoc
 */
gc.gis.OLWMTSProvider.prototype.getLayerConfig = function(capabilities, layerIdentifier, opt_options)
{
    opt_options = opt_options || {};

    const sourceConfig = {
        layer: layerIdentifier
    };

    if (opt_options.matrixSet)
    {
        sourceConfig.matrixSet = opt_options.matrixSet;
    }

    const capabilitiesLayer = capabilities.getLayerByIdentifier(layerIdentifier);
    const wmtsSource = optionsFromCapabilities(capabilities.getImpl(), sourceConfig);

    if (!wmtsSource || !capabilitiesLayer)
    {
        throw new gc.gis.error.GCError(`Layer nicht gefunden im WMTS Capabilities: ${layerIdentifier}`);
    }

    // WMTS-Layer funktionieren derzeit leider nur über den Umweg "externalConnection" als WMS-Fake
    return {
        isInternal: 'false',
        type: 'wms',
        originalType: 'external_wms',
        tiled: true,
        cached: true,
        showLegend: false,
        name: layerIdentifier,
        defaultLabel: capabilitiesLayer.title,
        abstract: capabilitiesLayer.abstract,
        projection: wmtsSource.projection.getCode(),
        format: wmtsSource.format,
        extent: wmtsSource.tileGrid.getExtent(),
        externalConnection: {
            source: 'wmts',
            url: wmtsSource.urls || wmtsSource.url,
            layers: layerIdentifier,
            styles: wmtsSource.style,
            matrixSet: wmtsSource.matrixSet,
            requestEncoding: wmtsSource.requestEncoding,
            origin: wmtsSource.tileGrid.getOrigin(0),
            resolutions: wmtsSource.tileGrid.getResolutions(),
            matrixIds: wmtsSource.tileGrid.getMatrixIds()
        }
    };
};

/**
 * @return {string}
 * @private
 */
gc.gis.OLWMTSProvider.prototype._buildCapabilitiesUrl = function(url)
{
    const capabilitiesUrl = gc.gis.GCUrl.fromString(url);

    if (!this._isRestService(capabilitiesUrl))
    {
        for (let q in capabilitiesUrl.queryObject)
        {
            if (capabilitiesUrl.queryObject.hasOwnProperty(q))
            {
                if (q.toUpperCase() === 'SERVICE' || q.toUpperCase() === 'REQUEST')
                {
                    delete capabilitiesUrl.queryObject[q];
                }
            }
        }
        capabilitiesUrl.queryObject.SERVICE = 'WMTS';
        capabilitiesUrl.queryObject.REQUEST = 'GetCapabilities';
    }

    return gc.gis.GCUrl.toString(capabilitiesUrl);
};

/**
 *
 * @param {gc.gis.GCUrl} url
 * @private
 */
gc.gis.OLWMTSProvider.prototype._isRestService = function(url)
{
    return url.path && url.path.endsWith('WMTSCapabilities.xml');
}